export type BrowseDestination = {
  name: string;
  href: string;
  description: string;
  /** Match only this path (Home). */
  exact?: boolean;
};

/** Primary public destinations for the Explore rail and header. */
export const BROWSE_DESTINATIONS: BrowseDestination[] = [
  {
    name: 'Home',
    href: '/',
    description: 'Your feed and what is happening next',
    exact: true,
  },
  {
    name: 'Discover',
    href: '/discover',
    description: 'Public builds from the community',
  },
  { name: 'Bilt:Spec Passport', href: '/passport', description: 'Your car spots, encounters, and memories' },
  {
    name: 'Events',
    href: '/events',
    description: 'Shows, meets, and awards',
  },
  {
    name: 'Clubs',
    href: '/clubs',
    description: 'Marques, regions, and crews',
  },
  {
    name: 'Shops',
    href: '/shops',
    description: 'Builders and specialists',
  },
];

export function isBrowseDestinationActive(pathname: string, item: BrowseDestination): boolean {
  if (item.exact || item.href === '/') {
    return pathname === item.href;
  }
  return pathname === item.href || pathname.startsWith(`${item.href}/`);
}

export function ownerProfilePath(
  username: string | null | undefined,
  options?: { addVehicle?: boolean }
): string {
  const u = (username || '').trim();
  if (!u) return '/';
  return options?.addVehicle ? `/${u}?add=1` : `/${u}`;
}
